import { render, staticRenderFns } from "./WoTermCategoryList.vue?vue&type=template&id=4944c9c6&"
import script from "./WoTermCategoryList.vue?vue&type=script&lang=js&"
export * from "./WoTermCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports